"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var tfs_form_item_1 = __importDefault(require("tfs.form-item"));
var tfs_form_input_1 = __importDefault(require("tfs.form-input"));
exports.default = (function (props) {
    var customProps = __assign(__assign({}, props), { type: 'number' });
    return (react_1.default.createElement(tfs_form_item_1.default, __assign({}, customProps),
        react_1.default.createElement(tfs_form_input_1.default, __assign({}, customProps))));
});
//# sourceMappingURL=FormNumberInput.js.map